export const topPerformingStaffSeries = [
  { name: "consultations", color: "green.5" },
  { name: "labs", color: "blue.5" },
  { name: "prescriptions", color: "orange.5" },
];

export const consultationsTrendSeries = [
  { name: "homecare", color: "indigo.5" },
  { name: "teleconsultation", color: "orange.5" },
];

export const labsTrendSeries = [
  { name: "ordered", color: "indigo.5" },
  { name: "completed", color: "orange.5" },
];

export const prescriptionsTrendSeries = [
  { name: "prescriptions", color: "indigo.5" },
];
